/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const SessionSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.7586 0H1.59483C0.71528 0 0 0.71528 0 1.59483V11.1638C0 12.0433 0.71528 12.7586 1.59483 12.7586H4.45435L7.17672 15.481L9.89909 12.7586H12.7586C13.6382 12.7586 14.3534 12.0433 14.3534 11.1638V1.59483C14.3534 0.71528 13.6382 0 12.7586 0ZM12.7586 11.1638H9.23884L7.17672 13.2259L5.11461 11.1638H1.59483V1.59483H12.7586V11.1638Z" fill="currentColor"/>
    <path d="M9.11719 7.73438C9.94561 7.73438 10.6172 7.0628 10.6172 6.23438C10.6172 5.40595 9.94561 4.73438 9.11719 4.73438C8.28876 4.73438 7.61719 5.40595 7.61719 6.23438C7.61719 7.0628 8.28876 7.73438 9.11719 7.73438Z" fill="currentColor"/>
    <path d="M4.53125 7.73438C5.35968 7.73438 6.03125 7.0628 6.03125 6.23438C6.03125 5.40595 5.35968 4.73438 4.53125 4.73438C3.70282 4.73438 3.03125 5.40595 3.03125 6.23438C3.03125 7.0628 3.70282 7.73438 4.53125 7.73438Z" fill="currentColor"/>
  </svg>
);

export const SessionDetailsIcon = props => <Icon component={SessionSvg} {...props} />;
